import { TenantRouteMeta } from '../types';
import { configurationRoutes } from './configuration';
import { integrationsRoutes } from './integrations';
import { contentRoutes } from './content';
import { programYearRoutes } from './programYear';
import { observabilityRoutes } from './observability';
import { adminRoutes } from './admin';
import { workflowRoutes } from './workflow';

/**
 * All tenant-scoped routes, composed from per-domain config files.
 * To add a new tenant page: create it in `src/pages/...`, then add a
 * route entry to the appropriate domain file. To expose it in the
 * sidebar, populate `sidebar` metadata — the sidebar nav generator
 * reads from here.
 */
export const allTenantRoutes: TenantRouteMeta[] = [
  ...configurationRoutes,
  ...integrationsRoutes,
  ...contentRoutes,
  ...programYearRoutes,
  ...observabilityRoutes,
  ...adminRoutes,
  ...workflowRoutes,
];

/**
 * Filter routes for the current build. Dev-only routes are dropped in
 * production bundles so static reference stubs and internal tooling
 * don't ship to end users.
 */
export const visibleTenantRoutes = (): TenantRouteMeta[] => {
  const isDev = process.env.NODE_ENV !== 'production';
  return allTenantRoutes.filter((r) => !r.devOnly || isDev);
};
